import { render, staticRenderFns } from "./driver-new-and-edit.vue?vue&type=template&id=3b253a55&scoped=true"
import script from "./driver-new-and-edit.vue?vue&type=script&lang=js"
export * from "./driver-new-and-edit.vue?vue&type=script&lang=js"
import style0 from "./driver-new-and-edit.vue?vue&type=style&index=0&id=3b253a55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b253a55",
  null
  
)

export default component.exports